import { z } from 'zod';

import { zodDatetime } from '../zodHelpers';

export const timeWindowSchema = z.object({
    start: zodDatetime(),
    end: zodDatetime(),
});
export type TimeWindow = z.infer<typeof timeWindowSchema>;
